import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			rx: 12,
			fill: "#FFF5D7"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_22641_41283)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M29.2411 35.1942C29.0387 35.6115 29.0547 36.1025 29.2828 36.5067L32.5238 42.06C32.798 42.5308 32.7712 43.1182 32.4557 43.5631C32.1525 44.0158 31.616 44.2525 31.0772 44.1751L24.7083 43.3345C24.4861 43.3032 24.2601 43.3253 24.0465 43.3964L23.719 43.5157C23.6116 43.574 23.5137 43.6508 23.4324 43.7434L19.1019 48.4988C18.8857 48.7282 18.6032 48.8845 18.2924 48.9444C17.5278 49.0698 16.8021 48.5623 16.6573 47.8006L15.5659 41.4639C15.4791 41.0041 15.1745 40.6155 14.7493 40.4214L8.84471 37.7827C8.35076 37.5617 8.03012 37.0763 8.02202 36.5358C8.00953 35.9983 8.29549 35.4985 8.76589 35.2381L14.4536 32.1781C14.8931 31.9645 15.193 31.5403 15.2487 31.0547L15.9174 24.6649C15.9362 24.5212 15.9767 24.3805 16.0402 24.2506L16.1181 24.1264C16.152 24.0429 16.1983 23.9671 16.2554 23.8984L16.3695 23.8021L16.5441 23.6426L17.0527 23.4572C17.5242 23.3387 18.0233 23.4648 18.3803 23.7946L23.0301 28.2184C23.3674 28.5431 23.8432 28.6804 24.3012 28.5888L30.624 27.2711C31.1579 27.1587 31.7097 27.3545 32.0538 27.7766C32.3887 28.2034 32.4459 28.7848 32.2011 29.2697L29.2411 35.1942Z",
					fill: "url(#paint0_linear_22641_41283)"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .5,
					filter: "url(#filter0_f_22641_41283)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M23.6717 31.9805C20.9064 31.9805 18.6621 34.2253 18.6621 36.9901C18.6621 39.7559 20.9064 41.9997 23.6717 41.9997C26.4421 41.9997 28.6814 39.7559 28.6814 36.9901C28.6814 34.2253 26.4421 31.9805 23.6717 31.9805Z",
						fill: "#E8B006"
					})
				}),
				/* @__PURE__ */ _jsx("foreignObject", {
					x: 1.67969,
					y: -5.68164,
					width: 69.3008,
					height: 69.9121,
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							backdropFilter: "blur(9px)",
							clipPath: "url(#bgblur_1_22641_41283_clip_path)",
							height: "100%",
							width: "100%"
						}
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-figma-bg-blur-radius": 18,
					d: "M39.6243 12.8726C39.6368 12.8757 39.6496 12.8796 39.6617 12.884C40.3162 13.1226 40.8177 13.6543 41.0174 14.3171L41.0539 14.4522L41.0546 14.4574L42.7902 22.4213L42.7906 22.4234C42.888 22.8828 43.2059 23.2657 43.6385 23.449L51.2249 26.5697L51.224 26.5694C51.9473 26.8651 52.459 27.5168 52.5805 28.2797L52.599 28.4344L52.5995 28.4405C52.6575 29.2734 52.2284 30.064 51.4985 30.4697L51.4978 30.4686L44.1666 34.5874C43.7671 34.8195 43.5052 35.2334 43.4653 35.695L42.9153 43.8427L42.9151 43.8437C42.8577 44.681 42.3161 45.4065 41.5301 45.7008L41.5294 45.6996C40.7556 46.009 39.8752 45.8469 39.2606 45.2876L39.2608 45.2867L33.167 39.8687L33.1656 39.8663C33.0404 39.7531 32.8953 39.663 32.7374 39.5987L32.5753 39.5428L32.1936 39.4469C32.0866 39.4382 31.9794 39.4451 31.8783 39.4714L31.8717 39.4737L23.9306 41.3872L23.9242 41.3886C23.4573 41.4926 22.9682 41.4485 22.526 41.2588L22.517 41.2545C21.439 40.756 20.9553 39.4882 21.4264 38.3977L21.429 38.3913L24.7967 30.9516C24.9814 30.5203 24.9469 30.027 24.7038 29.6263L20.3774 22.6447C19.9392 21.9369 19.9489 21.0411 20.4055 20.3449C20.8509 19.6554 21.6412 19.2688 22.4597 19.3426L22.4647 19.3429L30.6242 20.1788C30.6293 20.1793 30.6347 20.18 30.6398 20.1807C31.1265 20.251 31.6159 20.0674 31.9371 19.6941L37.1921 13.4556L37.198 13.448L37.1989 13.4483C37.3458 13.2827 37.5193 13.1366 37.7165 13.0235L37.7523 13.0053L37.9021 12.9382C38.0204 12.8642 38.146 12.8092 38.2763 12.7715L38.3409 12.7585L38.5155 12.741L38.8123 12.6977L38.8858 12.694C38.9099 12.6953 38.9339 12.6991 38.9575 12.705L39.6243 12.8726Z",
					fill: "#F5BA09",
					fillOpacity: .3,
					stroke: "url(#paint1_linear_22641_41283)",
					strokeWidth: .75,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_22641_41283",
				x: 3.66211,
				y: 16.9805,
				width: 40.0195,
				height: 40.0195,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 7.5,
						result: "effect1_foregroundBlur_22641_41283"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_1_22641_41283_clip_path",
				transform: "translate(-1.67969 5.68164)",
				children: /* @__PURE__ */ _jsx("path", { d: "M39.6243 12.8726C39.6368 12.8757 39.6496 12.8796 39.6617 12.884C40.3162 13.1226 40.8177 13.6543 41.0174 14.3171L41.0539 14.4522L41.0546 14.4574L42.7902 22.4213L42.7906 22.4234C42.888 22.8828 43.2059 23.2657 43.6385 23.449L51.2249 26.5697L51.224 26.5694C51.9473 26.8651 52.459 27.5168 52.5805 28.2797L52.599 28.4344L52.5995 28.4405C52.6575 29.2734 52.2284 30.064 51.4985 30.4697L51.4978 30.4686L44.1666 34.5874C43.7671 34.8195 43.5052 35.2334 43.4653 35.695L42.9153 43.8427L42.9151 43.8437C42.8577 44.681 42.3161 45.4065 41.5301 45.7008L41.5294 45.6996C40.7556 46.009 39.8752 45.8469 39.2606 45.2876L39.2608 45.2867L33.167 39.8687L33.1656 39.8663C33.0404 39.7531 32.8953 39.663 32.7374 39.5987L32.5753 39.5428L32.1936 39.4469C32.0866 39.4382 31.9794 39.4451 31.8783 39.4714L31.8717 39.4737L23.9306 41.3872L23.9242 41.3886C23.4573 41.4926 22.9682 41.4485 22.526 41.2588L22.517 41.2545C21.439 40.756 20.9553 39.4882 21.4264 38.3977L21.429 38.3913L24.7967 30.9516C24.9814 30.5203 24.9469 30.027 24.7038 29.6263L20.3774 22.6447C19.9392 21.9369 19.9489 21.0411 20.4055 20.3449C20.8509 19.6554 21.6412 19.2688 22.4597 19.3426L22.4647 19.3429L30.6242 20.1788C30.6293 20.1793 30.6347 20.18 30.6398 20.1807C31.1265 20.251 31.6159 20.0674 31.9371 19.6941L37.1921 13.4556L37.198 13.448L37.1989 13.4483C37.3458 13.2827 37.5193 13.1366 37.7165 13.0235L37.7523 13.0053L37.9021 12.9382C38.0204 12.8642 38.146 12.8092 38.2763 12.7715L38.3409 12.7585L38.5155 12.741L38.8123 12.6977L38.8858 12.694C38.9099 12.6953 38.9339 12.6991 38.9575 12.705L39.6243 12.8726Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_22641_41283",
				x1: 20.8008,
				y1: 20.2003,
				x2: 23.9476,
				y2: 47.4305,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E8B006" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F9BE09"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_22641_41283",
				x1: 27.6334,
				y1: 13.9743,
				x2: 40.3886,
				y2: 43.474,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .25
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_22641_41283",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 48,
					height: 48,
					fill: "white",
					transform: "translate(6 6)"
				})
			})
		] })
	]
});
export default SvgRate;
